<script>
    import ContextualText from '../Workspaces/ElementView/ContextualText.svelte';
    import {draftElementDetails} from '../Workspaces/workspacesStore.js';
    import TextInput from '../TextInput.svelte';
    import {PATH_PREFIX} from '../../apiUrls';

    export let editable = false;
    export let onChange = () => {};

    export let model = {};
</script>

<style>
    .wrapper {
        background-color: #f8f9fa;
        border: 1px solid #ced4da;
    }

    .wrapper > div {
        padding: 10px;
    }
</style>

<div class="wrapper">
    <div>
        {#if editable}
            <TextInput
                id="corrective_action"
                bind:value={model.corrective_action}
                object={model}
                on:change={onChange}
            />
        {:else}
            {#if model.corrective_action_element}
                <a href="{PATH_PREFIX}/sw/elements_database/{model.corrective_action_element.id}/edit/" target="_blank" rel="noopener noreferrer">{model.corrective_action}</a>
            {:else}
                {model.corrective_action ? model.corrective_action : '-'}
            {/if}
        {/if}
    </div>
</div>
